import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

// Components
import NavigationHeader from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import WhatsAppFab from "./components/WhatsAppFab/WhatsAppFab";

// Routes
import ProtectedRoute from "./routes/ProtectedRoute";
import AdminRoute from "./routes/AdminRoute";

// Views
import WhoWeServe from "./views/WhoWeServe/WhoWeServe";
import PartnerOffers from "./views/PartnerOffers/PartnerOffers";
import Pricing from "./views/Pricing/Pricing";
import Features from "./views/Features/Features";
import AboutUs from "./views/AboutUs/AboutUs";
import Contact from "./views/Contact/Contact";
import Register from "./views/Register/Register";
import NotFound from "./views/NotFound/NotFound";
import EsimPlatform from "./views/EsimPlatform/EsimPlatform";
import TermsPage from "./views/Static/TermsPage";
import PrivacyPage from "./views/Static/PrivacyPage";
import ApiPortal from "./views/ApiPortal/ApiPortal";
import EsimStats from "./views/EsimStats/EsimStats";
import MyEsims from "./views/MyEsim/MyEsims";
import Offer from "./views/Offer/Offer";
import SignIn from "./views/SignIn/SignIn";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="app-wrapper">
          <header>
            <div className="container">
              <NavigationHeader />
            </div>
          </header>
          <main className="app-main">
            <Routes>
              <Route path="/" element={<WhoWeServe />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/features" element={<Features />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/esim-platform" element={<EsimPlatform />} />
              <Route path="/partner-offers" element={<PartnerOffers />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy-policy" element={<PrivacyPage />} />
              <Route
                path="/doc"
                element={
                  // <ProtectedRoute>
                    <ApiPortal />
                  // </ProtectedRoute>
                }
              />
              <Route
                path="/esim-stats"
                element={
                  <AdminRoute>
                    <EsimStats />
                  </AdminRoute>
                }
              />

              <Route
                path="/my-esims"
                element={
                  <ProtectedRoute>
                    <MyEsims />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/offer"
                element={
                  <ProtectedRoute>
                    <Offer />
                  </ProtectedRoute>
                }
              />

              <Route path="/become-a-partner" element={<Register />} />
              <Route path="/sign-in" element={<SignIn />} />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <WhatsAppFab
            phone="4915905555577"
            // message="Hello Globtel, I’d like a demo of your eSIM platform"
          />
          <Footer />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
